import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ToastService } from 'src/app/modules/shared/toast/toast.service';
import { HelplinkService } from '../../services/helplink.service';
import { HelpLinkReq } from '../../models/HelpLinkReq';
import { CustomRegExp } from 'src/app/modules/shared/services/regex';
import { GlobalStoreService } from '../../services/global-store.service';

@Component({
  selector: 'app-help',
  standalone: false,
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {

  isIssueSelected:boolean=false;
  request:HelpLinkReq;

  helpForm= new FormGroup(
    {
      type:new FormControl(''),
      issuefrequency:new FormControl(''),
      description:new FormControl('')
    })


  constructor(private toastService: ToastService,private service:HelplinkService,public globalStore: GlobalStoreService) { 
    this.request=new HelpLinkReq();
  }

  ngOnInit(): void { 
    
  }

  onSubmit()
  {
    if (!this.helpForm.get('description').value.match(new CustomRegExp(this.globalStore.regexValidatorSIDPrject,'g'))) {
      this.toastService.show('only valid characters are allowed')
      return;
    }else {
      this.getRequest();    
      this.toastService.show('Data Submitted Successfully')
      this.service.saveHelpLinkDetails(this.request).subscribe(
        data=>
        {                    
          if(data.Message==='Data Inserted Successfully') 
            this.service.sendEmail(this.request).subscribe()                            
        }
      )
      this.helpForm.reset();
      this.isIssueSelected=false;
    }
  }


    getRequest()
    {
      this.request.type=this.helpForm.get('type').value;      
      this.request.frequency=this.helpForm.get('type').value=='issue'?this.helpForm.get('issuefrequency').value:null;
      this.request.description=this.helpForm.get('description').value
    }

    onDropDownChange()
    {
      let type=this.helpForm.get('type').value;      
      if(type=='issue')
      {
        this.isIssueSelected=true;
      }
      else
      {
        this.isIssueSelected=false;
      }
    }

    isHelpFormValid()
    {      
      if(this.helpForm.get('type').value=='suggestion')
      {        
        if(this.helpForm.get('description').value!=null && this.helpForm.get('description').value.trim()!='')
          return true;      
        else 
          return false;
      }
      else
      {
        if(this.helpForm.get('description').value!=null && this.helpForm.get('description').value.trim()=='')
        {
          return false;
        }
        else
          return this.helpForm.valid;
      }
      
    }

}
